var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
import { stringBuilder } from '../util';
const isRoute = (link) => !!link.route;
const TuxGlobalFooter = (props) => {
    const { children, links = [], className } = props, rest = __rest(props, ["children", "links", "className"]);
    const classes = stringBuilder('footer', className);
    return (_jsxs("footer", Object.assign({}, rest, { className: classes, role: "contentinfo" }, { children: [_jsx("ul", Object.assign({ className: "links" }, { children: links.map((link, i) => (_jsx("li", { children: isRoute(link) ? (_jsx(Link, Object.assign({ to: link.route }, { children: link.name }), void 0)) : (!!link.url && _jsx("a", Object.assign({ href: link.url }, { children: link.name }), void 0)) }, i))) }), void 0), children] }), void 0));
};
export default TuxGlobalFooter;
